module.exports = __webpack_public_path__ + "img/syncIcon.7a6122e9.svg";